export default __webpack_public_path__ + "static/media/3.45f8a9c0.jpg";